<template>
  <div
    class="scmcc-error-page"
  >
    <div class="error-page-wrapper">
        <h2 class="error-title">{{getMessage}}</h2>
    </div>
  </div>
</template>
<script>
export default {
  name: 'error',
  data: () => ({
    // getMessage: ''
  }),
  computed: {
    getMessage () {
      if(this.$route.query.errorMessage) {
        return this.$route.query.errorMessage
      } else {
        return '无效Token，请重新获取'
      }
    }
  }
}
</script>

<style lang="stylus">
.scmcc-error-page
  height 100%
  width 100%
  overflow-y auto
  background #F3F6FC
  background-position center bottom
  background-repeat repeat-x
  text-align center

  .error-title
      line-height 200px
</style>
